.signet-progress {
  display: flex;
  justify-content: space-between;
  position: relative;
}

.signet-progress::after {
  content: '';
  width: 100%;
  height: 2px;
  background-color: rgb(0 0 0 / 12%);
  position: absolute;
  top: 50%;
  right: 0;
}

.signet-progress-step {
  position: relative;
}

.signet-progress-step.complete {
  .complete-icon {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    color: var(--primary-main);
    line-height: 0;
    z-index: 21;

    .material-icons {
      font-size: 17px !important;
    }
  }

  .label {
    padding-left: 22px;
    color: var(--primary-main);
    font-size: 15px;

    &::before {
      border: none;
    }
  }
}

.signet-progress-step.in-progress {
  .label {
    color: var(--primary-main);

    &::before {
      content: '';
      outline: 1px solid var(--primary-main);
      outline-offset: 1px;
      width: 10px;
      height: 10px;
      background-color: var(--primary-main);
      z-index: 21;
    }
  }
}

.label {
  padding-left: 1.8rem;
  padding-right: 5px;
  cursor: pointer;
  position: relative;
  background-color: var(--solid-background-general-app);
  z-index: 20;

  &::before {
    content: '';
    width: 14px;
    height: 14px;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 8px;
    transform: translateY(-50%);
    border: 1px solid #00000061;
    z-index: 21;
  }
}

.signet-progress-step.disabled {
  cursor: not-allowed;
}
